import {
  DEFAULT_ASSUMPTIONS,
  type JPBAssumptions,
  type JPBReferenceProperty,
} from "src/modules/JPBModule/JPBState";

export type JPBSkovDemoFilters = {
  selectedLayerId?: number;
  bufferDistanceKm: number;
};

export type JPBSkovDemoResults = {
  loading: boolean;
  error: string | null;
  properties: JPBReferenceProperty[];
};

/**
 * JPB's assumption checks treat “no mark overlap data” as 0%. Default threshold 25%
 * then excludes almost all forest/demo rows. Use -1 so any real overlap % (≥0) passes.
 */
export function buildSkovDemoNeutralAssumptions(
  properties: readonly JPBReferenceProperty[],
): JPBAssumptions {
  const types = new Set<string>([...DEFAULT_ASSUMPTIONS.includeTransactionTypes]);
  for (const p of properties) {
    if (p.transactionType) types.add(p.transactionType);
  }
  const includeTransactionTypes = Array.from(types).sort();
  return {
    ...DEFAULT_ASSUMPTIONS,
    effectiveMarkOverlapThreshold: -1,
    areaMin: 0,
    areaMax: Number.MAX_SAFE_INTEGER,
    pricePerMeterMin: 0,
    pricePerMeterMax: Number.MAX_SAFE_INTEGER,
    buildingAreaOkM2: 0,
    excludeBuildings: false,
    includeTransactionTypes,
  };
}

export function initialJPBSkovDemoFilters(): JPBSkovDemoFilters {
  return {
    selectedLayerId: undefined,
    bufferDistanceKm: 10,
  };
}

export function initialJPBSkovDemoResults(): JPBSkovDemoResults {
  return {
    loading: false,
    error: null,
    properties: [],
  };
}
